import Button from 'ui/components/buttons/Button'
import { ButtonGroup } from 'ui/components/buttons/Button/styled'
import ModalBasic from 'ui/components/ModalBasic'

const ConfirmModal = ({
  title,
  text,
  open,
  confirmHandler,
  handlerClose,
  confirmText = 'Да',
  cancelText = 'Нет',
  confirmDisabled = false,
}) => {
  return (
    <ModalBasic
      open={open}
      handlerClose={handlerClose}
      title={title}
      text={text}
    >
      <ButtonGroup>
        <Button
          title={confirmText}
          onClick={confirmHandler}
          type="button"
          disabled={confirmDisabled}
        />
        <Button
          title={cancelText}
          theme="borderBlue"
          type="reset"
          onClick={handlerClose}
        />
      </ButtonGroup>
    </ModalBasic>
  )
}

export default ConfirmModal
